import {BaseModal, ModalCloseButton} from "./ModalBase";
import {SelectOptions} from "../ui/Select";
import React, {useState} from "react";
import {Typography} from "../ui/Typography";
import {Input} from "../ui/Input";
import {Button} from "../ui/Button";
import {LucideCheck} from "lucide-react";

interface ContactModalProps {
    isOpen: boolean;
    onClose: () => void;
}


export const ContactModal = ({isOpen, onClose}: ContactModalProps) => {
    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            containerClassName="w-[min(150vw,528px)] max-h-[min(92vh, 850px)] bg-surface-950 border-surface-800 p-10"
        >
            <ModalCloseButton onClose={onClose} />
            
                <div className="text-center mb-12 md:mb-16">

                    <Typography 
                        as="h1" 
                        variant="h2" 
                        className="text-4xl sm:text-5xl"
                    > 
                        Contact us
                        <span className="text-brand-500" >.</span>
                    </Typography>

                    <Typography as="p" variant="p">
                        Questions, issues or requests? Our team is here to help!
                    </Typography>
       
                </div>

                <ContactForm/>
            
        </BaseModal>    
    )
}

const ContactForm = (any) => {

    const [isMessageSend, setIsMessageSend] = useState(false);
    
    const handleSendMessage = () => {
        setIsMessageSend(true);
    };
    
    return (
        <>
            <form action="#" method="POST" id="contact-form">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="w-full">
                        <Typography as="label" variant="label">First Name</Typography>
                        <Input
                            type="text"
                            placeholder="Edwin"
                            inputSize="small"
                            required
                        />
                        {/*todo: add logic for required fields*/}
                        {/*<Typography as="label" variant="labelError" className="mt-2">This field is required.</Typography>*/}
                    </div>

                    <div className="w-full">  {/* Added w-full here */}
                        <Typography as="label" variant="label">Last Name</Typography>
                        <Input
                            type="text"
                            placeholder="Great"
                            inputSize="small"
                            required
                        />
                    </div>
                </div>

                <div className="mt-5 mb-5">
                    <Typography as="label" variant="label">Email Address</Typography>
                    <div>
                        <Input
                            type="email"
                            placeholder="you@gmail.com"
                            className="w-full"
                            required
                        />
                    </div>
                    {/*<Typography as="label" variant="labelError" className="mt-2">This field is required.</Typography>*/}
                </div>

                <div className="relative mt-5 mb-5">
                    <Typography as="label" variant="label">Reason for Contact</Typography>
                    <ContactSelectOptions />
                </div>

                <div className="mt-5 mb-5">
                    
                    <Typography as="label" variant="label" className="block mb-2">
                        Your Message
                    </Typography>
    
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Tell us how we can help..."
                        rows={5}
                        required
                        className="w-full p-4 bg-surface-950 border border-surface-700 rounded-lg text-surface-400 
                                  placeholder-surface-700 transition-colors duration-200 focus:outline-none focus:ring-2 
                                  focus:ring-brand-500/50 focus:border-brand-500 resize-none"
                    />
                </div>

                {/*<Typography as="label" variant="labelError" className="mt-2">This field is required.</Typography>*/}

                {isMessageSend ? 
                    <Typography 
                        as="p" 
                        variant="p"
                        className="flex items-center gap-2"
                    >
                        <LucideCheck className="text-brand-500" />
                        Message successfully sent!
                    </Typography> :
                    <Button
                        size="large"
                        className="mt-6"
                        onClick={() => handleSendMessage()}>
                        Send Message
                    </Button> 
                }
                
            </form>
        </>
    );
};


const ContactSelectOptions = () => {
    const optionsArr = ['General Question', 'Icon Request', 'Technical Support', 'Billing', 'Partnership']
    return (
        <SelectOptions sizing="large">
            {optionsArr.map((opt) => <option>{opt}</option>)}
        </SelectOptions>
    );
};


































